import React from 'react'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'

import { CategoryIcon, Text } from '@mxenabled/mxui'

import { StatusBar } from '../../../common'
import { DetailedBudget } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface HeaderProps {
  budget: DetailedBudget
}

export const Header: React.FC<HeaderProps> = ({ budget }) => {
  const {
    amount,
    budgetColors: { background },
    category: { name: categoryName },
    category_guid,
    percentage,
    transaction_total,
  } = budget

  const status = [
    {
      color: background,
      percentage: `${percentage}%`,
    },
  ]

  return (
    <Card sx={{ mt: 24, mx: 24 }}>
      <CardContent>
        <Stack alignItems="center" gap={16}>
          <CategoryIcon categoryGuid={category_guid} size={56} />
          <Text variant="h1">
            {`${formatCurrency(transaction_total, '0,0')} / ${formatCurrency(amount, '0,0')}`}
          </Text>
          <Text bold={true} variant="caption">
            {categoryName}
          </Text>
          <StatusBar data={status} height={10} />
        </Stack>
      </CardContent>
    </Card>
  )
}
